import React from "react";

const EditIcon = ({ size = 345, h = "10", fill = "#4361E9" }) => {
  // create the height and width based on the size prop, default width is 345 and height is 231
  const width = (size / 345) * 345;
  const height = (size / 345) * 231;
  return (
    <svg
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.84432 2.3623H2.12513C1.8433 2.3623 1.57302 2.47426 1.37374 2.67354C1.17445 2.87282 1.0625 3.14311 1.0625 3.42493V10.8633C1.0625 11.1451 1.17445 11.4154 1.37374 11.6147C1.57302 11.814 1.8433 11.9259 2.12513 11.9259H9.56352C9.84534 11.9259 10.1156 11.814 10.3149 11.6147C10.5142 11.4154 10.6261 11.1451 10.6261 10.8633V7.14413"
        stroke="#1E40AF"
        stroke-width="1.06263"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.82879 1.56547C10.0402 1.3541 10.3268 1.23535 10.6258 1.23535C10.9247 1.23535 11.2114 1.3541 11.4227 1.56547C11.6341 1.77684 11.7528 2.06352 11.7528 2.36244C11.7528 2.66136 11.6341 2.94804 11.4227 3.15941L6.37525 8.20689L4.25 8.7382L4.78131 6.61295L9.82879 1.56547Z"
        stroke="#1E40AF"
        stroke-width="1.06263"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default EditIcon;
